export default Object.freeze({
  Tasks: 1, // "tasks"
  MyDay: 2, // "my-day" Overdue hoy, las creadas hoy sin fecha de vencimiento, tareas que tienen la fecha planificada para hoy
  Favorites: 3, // "favorites"
  Planned: 4, // "planned"
  Overdue: 5, // "overdue"
  Custom: 6, // "custom"
});
